<template>
  <div id="lactationres-view">
    <head>
      <meta name="description" content="Explore lactation resources for successful breastfeeding, classes, support groups, maintenance, milk storage, flange sizes, local and national support, pumping">
    </head>
    <section class="bg-light ftco-section">
      <div class="container ">
        <h1 class="display-4 text-center  my-4">Lactation Resources</h1>
        <p class="text-center">Below you will find helpful resources for your breastfeeding journey. This page of
          resources was put together
          for our community by our Lactation Consultant and Registered nurse Jodie Dresel. </p>
    
      </div>
      <lactationres-icons></lactationres-icons>
    </section>
    <section class="resBg">
    </section>
    <img src="@/assets/site/images/flower-1.webp" alt class="img-fluid res-flower" />
    <section class="">
      <div class="container my-5">
        <div class="text-center my-5">
          <p class="text-uppercase">Best Start</p>
          <router-link to="/lactation_res/best_start">
            <img src="@/assets/site/images/icons/1.svg" alt />
          </router-link>
          <h2 class="display-4 text-center  my-4">Successful Breastfeeding</h2>
          <p class="text-left">Breastfeeding is the gold standard in infant feeding. Breastmilk provides immune support
            with amazing
            antibodies to give your baby everything they need and the best start for a healthy life. The American
            Academy
            of Pediatrics recommends exclusive breastfeeding for 6 months, introducing foods after 6 months of life and
            continuing breastfeeding for a year and beyond. The World Health Organization recommends breastfeeding for
            two
            years and beyond…More ></p>
        </div>
        <div class="text-center my-5">
          <p class="text-uppercase">support</p>
          <router-link to="/lactation_res/classes">
            <img src="@/assets/site/images/icons/2.svg" alt />
          </router-link>
          <img src="@/assets/site/images/bird-left.webp" alt class="img-fluid res-bird-left" />
          <h2 class="display-4 text-center  my-4">Classes, Support Groups</h2>
          <img src="@/assets/site/images/graphic-11.webp" alt class="img-fluid res-graphic-11" />
          <p class="text-left">Bringing a new life into the word is amazing but not everything with that comes easily
            and
            no new parent should feel alone in the journey. This group is facilitated by our Jodie our Lactation Consultant. Get support, meet other moms and get the help you need
            from our Lactation Consultant… <router-link to="/lactation_res/classes">More></router-link>
          </p>
        </div>

        <div class="text-center my-5">
          <p class="text-uppercase">Maintenance</p>
          <a href="/pdf/breast-pump-cdc cleaning.pdf" 
              download="breast-pump-cdc cleaning.pdf"
              rel="nofollow">
            <img src="@/assets/site/images/icons/3.svg" class="img-fluid" alt />
          </a>
          <h2 class="display-4 text-center  my-4">How to Keep Your<br>
            Breast Pump Kit Clean</h2>

          <p class="text-left">Providing breast milk is one of the best things you can do for your baby’s health and
            development. Pumping your milk is one way to provide breast milk to your baby. Keeping the parts of your
            pump
            clean is critical, because germs can grow quickly in breast milk or breast milk residue that remains on pump
            parts… <a href="/pdf/breast-pump-cdc cleaning.pdf" 
            download="breast-pump-cdc cleaning.pdf"
            rel="nofollow">Download PDF></a>
          </p>
        </div>
        <div class="text-center my-5">
          <p class="text-uppercase">Best Practices</p>
          <a href="/pdf/Best_Practices_for_Milk_Storage.pdf" download="Best_Practices_for_Milk_Storage.pdf" rel="nofollow">
            <img src="@/assets/site/images/icons/4.svg" class="img-fluid " alt /></a>
          <h2 class="display-4 text-center  my-4">Milk Storage</h2>
          <p class="text-left">By following recommended storage and preparation techniques, nursing mothers and
            caretakers of breastfed infants and children can maintain the safety and quality of expressed breast milk
            for the health of the baby… <a href="/pdf/Best_Practices_for_Milk_Storage.pdf"
            rel="nofollow"
              download="Best_Practices_for_Milk_Storage.pdf">Download PDF ></a></p>
        </div>
        <div class="text-center my-5">
          <p class="text-uppercase">Know Your Size</p>
          <router-link to="/lactation_res/flange_size">
            <img src="@/assets/site/images/icons/5.svg" alt />
          </router-link>
          <h2 class="display-4 text-center  my-4">Flange-shield size information</h2>
          <p class="text-left"> A breast pump flange is the plastic piece that fits around your areola, over your nipple
            to form a seal to create the vacuum needed for milk extraction. The flange is also known as a breast shield.
            Incorrect sized flanges can impact milk production, cause pain and nipple damage with milk expression…
            <router-link to="/lactation_res/flange_size">More></router-link>
          </p>
        </div>
        <div class="text-center my-5">
          <p class="text-uppercase">Local & National</p>
          <img src="@/assets/site/images/graphic-12.webp"  alt
            class="img-fluid res-graphic-12" />
          <router-link to="/lactation_res/national">
            <img src="@/assets/site/images/icons/6.svg" class="img-fluid " alt />
          </router-link>
          <h2 class="display-4 text-center  my-4">Breastfeeding resources</h2>
          <p class="text-left">Local Breastfeeding Support Resources for all Hawaiian islands including a list of
            International Board Certified Lactation Consultants can be found at www.breastfeedinghawaii.org…
            <router-link to="/lactation_res/national">More></router-link>
          </p>
        </div>
        <div class="text-center my-5">
          <p class="text-uppercase">Back to Work</p>
          <router-link to="/lactation_res/pumping">
            <img src="@/assets/site/images/icons/7.svg" class="img-fluid" alt />
          </router-link>
          <h2 class="display-4 text-center  my-4"> Pumping and back to work</h2>
          <p class="text-left">Do you need a breast pump? Most moms find having a breast pump helpful while away from
            baby
            to maintain milk supply, to relieve engorgement and to increase milk supply if needed. Many moms who return
            to
            work need to have a pump to maintain milk supply while working… <router-link to="/lactation_res/pumping">
              More></router-link>
          </p>
        </div>
        <div class="text-center " id="icons-text1">
    
          <h2 class="display-4 text-center  my-4"> More information </h2>

          <p>including videos on latching, breastfeeding, positions, hand expression and much more please go to:</p>
          <a href="https://globalhealthmedia.org/videos" target="_blank"><h3 style="word-wrap: break-word; font-size: 1.5em;">https://globalhealthmedia.org/videos/</h3></a>

          <p class="text-center">Thank you to the Global Health Media Project for sharing<br> Breastfeeding education
            with moms
            and babies all over the world.
          </p>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="resources-text text-center pb-3">
              <p style="font-size: 0.7em; line-height: 1.2;">This information is to be used at the discretion of the individual and is not a substitute for medical advice. 
                Please contact your lactation consultant or primary care provider for medical advice. This list of resources was put together by Jodie Dresel RN, IBCLC. </p>
            </div>
          </div>
        </div>
        <img src="@/assets/site/images/res-graphic.webp"  alt
        class="img-fluid res-leaf-2" />
      </div>
    </section>
    <img src="@/assets/site/images/bird-left.webp" alt class="img-fluid res-bird-left-1" />
  </div>
</template>

<script>
    import LactationresIcons from '@/views/site/LactationresIcons'
    export default {
        name: "LactationresView",
        components: {
            LactationresIcons,
        },
    };
</script>